// This file was auto-generated by 'typesafe-i18n'. Any manual changes will be overwritten.
/* eslint-disable */

import { initFormatters } from './formatters'
import type { Locales, Translations } from './i18n-types'
import { loadedFormatters, loadedLocales, locales } from './i18n-util'

import da from './da'
import de from './de'
import en from './en'

import da_capture from './da/capture'
import da_desktop_web from './da/desktop-web'
import da_learn from './da/learn'
import da_shared from './da/shared'
import de_capture from './de/capture'
import de_desktop_web from './de/desktop-web'
import de_learn from './de/learn'
import de_shared from './de/shared'
import en_capture from './en/capture'
import en_desktop_web from './en/desktop-web'
import en_learn from './en/learn'
import en_shared from './en/shared'

const localeTranslations = {
	da: {
		...da,
		capture: da_capture,
		'desktop-web': da_desktop_web,
		learn: da_learn,
		shared: da_shared
	},
	de: {
		...de,
		capture: de_capture,
		'desktop-web': de_desktop_web,
		learn: de_learn,
		shared: de_shared
	},
	en: {
		...en,
		capture: en_capture,
		'desktop-web': en_desktop_web,
		learn: en_learn,
		shared: en_shared
	},
}

export const loadLocale = (locale: Locales): void => {
	if (loadedLocales[locale]) return

	loadedLocales[locale] = localeTranslations[locale] as unknown as Translations
	loadFormatters(locale)
}

export const loadAllLocales = (): void => locales.forEach(loadLocale)

export const loadFormatters = (locale: Locales): void =>
	void (loadedFormatters[locale] = initFormatters(locale))
